import React from "react";

import PropTypes from "prop-types";

import Button from "../Button";
import {useTranslation} from "react-i18next";
import {NAME_SPACES} from "../../locals/constants";

const NextPreviousFooter = ({
	                            onPreviousClick,
	                            previousEnabled,
	                            hidePrevious,
	                            onNextClick,
	                            nextEnabled,
	                            nextLoading,
                            }) => {

	const {t} = useTranslation(NAME_SPACES.GLOBAL);
	return (
			<div className={"newfolder--wrapper--footer"}>
				<div className={"newfolder--wrapper--footer--left"}>
					{!hidePrevious && (
							<Button
									text={t('PREVIOUS')}
									variant={"BORDERED"}
									disabled={!previousEnabled}
									onClick={onPreviousClick}
							/>
					)}
				</div>
				<div className={"newfolder--wrapper--footer--right"}>
					<Button
							text={t('NEXT')}
							disabled={!nextEnabled}
							loading={nextLoading}
							onClick={onNextClick}
					/>
				</div>
			</div>
	);
};

NextPreviousFooter.propTypes = {
	onNextClick: PropTypes.func,
	onPreviousClick: PropTypes.func,
	previousEnabled: PropTypes.bool,
	nextEnabled: PropTypes.bool,
	nextLoading: PropTypes.bool,
	hidePrevious: PropTypes.bool,
};

NextPreviousFooter.defaultProps = {
	onNextClick: () => {
	},
	onPreviousClick: () => {
	},
	previousEnabled: false,
	nextEnabled: false,
	hidePrevious: false,
};
export default NextPreviousFooter;
